import React, {useContext} from "react";
import {ReactKeycloakProvider} from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import axiosInstance from "../../../common/src/api/AxiosInstance";
import {UserContext} from "../context/UserContext"
import {Role} from "./roles";

const isAuthDisabled = window._env_?.disableAuth === true;

// Stand-in for keycloak-js that satisfies the subset of the API
// @react-keycloak/web and this app actually call, so local dev can render the
// portal (roles-gated tabs included) without a real Keycloak login. Pair with
// the backend's "public" Spring profile, which skips JWT validation entirely.
class LocalMockKeycloak {
    constructor() {
        this.authenticated = true;
        this.token = "local-dev-token";
        this.idToken = "local-dev-id-token";
        this.refreshToken = "local-dev-refresh-token";
        this.tokenParsed = {
            sub: "local-dev-user",
            name: "Local Dev",
            given_name: "Local",
            family_name: "Dev",
            realm_access: {roles: Object.values(Role)}
        };
    }

    init() {
        return Promise.resolve().then(() => {
            this.onReady && this.onReady(this.authenticated);
            this.onAuthSuccess && this.onAuthSuccess();
            return this.authenticated;
        });
    }

    updateToken() {
        return Promise.resolve(false);
    }

    login() {
        console.info("[local-dev] mock Keycloak login() is a no-op (window._env_.disableAuth)");
    }

    logout() {
        console.info("[local-dev] mock Keycloak logout() is a no-op (window._env_.disableAuth)");
    }
}

if (isAuthDisabled) {
    console.warn("[local-dev] Keycloak auth is DISABLED (window._env_.disableAuth) — using a mock user with every role.");
}

// Keycloak configuration that assumes it is proxied by the local server based on the path /auth.
const keycloak = isAuthDisabled
    ? new LocalMockKeycloak()
    : new Keycloak({
        url: "/auth",
        realm: window._env_.realm,
        clientId: window._env_.clientId
    });

const Auth = (props) => {
    const {setUser} = useContext(UserContext);
    const initialOptions = {
        onLoad: 'login-required',
        pkceMethod: 'S256',
        enableLogging: false,
        silentCheckSsoFallback: true,
        checkLoginIframe: false,
        checkLoginIframeInterval: 30
    }

    const onTokens = (tokens) => {

        const userData = {
            id: keycloak.tokenParsed?.sub,
            accessToken: tokens?.token,
            firstName: keycloak.tokenParsed?.given_name,
            lastName: keycloak.tokenParsed?.family_name,
            roles: keycloak.tokenParsed?.realm_access?.roles,
            hasLoaded: false
        }

        axiosInstance.setAuthToken(tokens.token || null);
        setUser({
            ...userData,
            hasLoaded: true
        });

    }

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={initialOptions}
      LoadingComponent={<div/>}
      isLoadingCheck={() => !keycloak.authenticated}
      onTokens={onTokens}
    >
      {props.children}
    </ReactKeycloakProvider>)
}

export default Auth;
